import React from 'react'
import { SaveIcon } from 'lucide-react'
import {
  DcButton,
  DcDiv,
  DcInput,
  DcText,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'

import { addNewSupplier } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const AddSupplier = (props) => {
  const { showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const { handleClose } = props
  const [data, setData] = React.useState({
    supplier_name: '',
    contact_person: '',
    phone: '',
    address: '',
  })

  const handleSubmit = (e) => {
    showPageLoader()
    e.preventDefault()
    addNewSupplier(data).subscribe((res: any) => {
      handleClose(res.response.data)
      hidePageLoader()
    })
  }

  return (
    <Form onSubmit={handleSubmit}>
      {/* <FormGroup> */}
      <DcDiv
        width="100%"
        height="auto"
        style={{
          display: 'flex',

          flexDirection: 'column',
          alignItems: 'flexStart',
        }}
      >
        <DcText
          style={{
            textAlign: 'left',

            color: '#2e314a',
            fontSize: '.875rem',
            fontWeight: '500',
            marginBottom: '.5rem',
          }}
        >
          Supplier Name
        </DcText>
        <DcInput
          required
          type={'text'}
          name={'supplier_name'}
          placeholder={'Supplier Name'}
          value={data.supplier_name}
          onChange={(e) => setData({ ...data, supplier_name: e.target.value })}
        />
      </DcDiv>
      {/* </FormGroup>/ */}

      {/* <FormGroup> */}
      <DcDiv
        width="100%"
        height="auto"
        style={{
          display: 'flex',

          flexDirection: 'column',
          alignItems: 'flexStart',
        }}
      >
        <DcText
          style={{
            textAlign: 'left',

            color: '#2e314a',
            fontSize: '.875rem',
            fontWeight: '500',
            marginBottom: '.5rem',
          }}
        >
          Contact Person
        </DcText>
        <DcInput
          required
          type={'text'}
          name={'contact_person'}
          placeholder={'Contact Person'}
          value={data.contact_person}
          onChange={(e) => setData({ ...data, contact_person: e.target.value })}
        />
      </DcDiv>
      {/* </FormGroup> */}

      {/* <FormGroup> */}
      <DcDiv
        width="100%"
        height="auto"
        style={{
          display: 'flex',

          flexDirection: 'column',
          alignItems: 'flexStart',
        }}
      >
        <DcText
          style={{
            textAlign: 'left',

            color: '#2e314a',
            fontSize: '.875rem',
            fontWeight: '500',
            marginBottom: '.5rem',
          }}
        >
          Phone
        </DcText>
        <DcInput
          required
          type={'text'}
          name={'phone'}
          placeholder={'Phone'}
          value={data.phone}
          onChange={(e) => setData({ ...data, phone: e.target.value })}
        />
      </DcDiv>
      {/* </FormGroup> */}

      {/* <FormGroup> */}
      <DcDiv
        width="100%"
        height="auto"
        style={{
          display: 'flex',

          flexDirection: 'column',
          alignItems: 'flexStart',
        }}
      >
        <DcText
          style={{
            textAlign: 'left',

            color: '#2e314a',
            fontSize: '.875rem',
            fontWeight: '500',
            marginBottom: '.5rem',
          }}
        >
          Supplier Address
        </DcText>
        <DcInput
          required
          as={'textarea'}
          name={'address'}
          placeholder={'Supplier Address'}
          value={data.address}
          onChange={(e) => setData({ ...data, address: e.target.value })}
        />
      </DcDiv>
      {/* </FormGroup> */}
      <FormGroup>
        <DcButton
          style={{ display: 'inline-flex', gap: '5px', alignItems: 'center' }}
          type={'submit'}
          size="sm"
        >
          <SaveIcon size={16} />
          <span>Save</span>
        </DcButton>
      </FormGroup>
    </Form>
  )
}
const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: flex-end;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

export default AddSupplier
